export async function fetchCountries() {
  try {
    const res = await fetch('https://ofm.stran.store/api/magento/countries');
    const json = await res.json();

    return json.data || [];
  } catch (err) {
    console.error('Error fetching countries:', err);
    return [];
  }
}

export async function fetchProductBySku(sku) {
  try {
    const res = await fetch(`https://ofm.stran.store/api/magento/products/${sku}`);
    const json = await res.json();
    return json
  } catch (err) {
    console.error('Error fetching product:', err);
    return
  }
}

export async function fetchProductsBySearchCriteria(filterGroups) {
  try {
    const res = await fetch('https://ofm.stran.store/api/magento/products/search', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filters: filterGroups }),
    });
    if (!res.ok) throw new Error('Failed to fetch');
    return await res.json();
  } catch (err) {
    console.error('Error fetching products:', err);
    return null;
  }
}

export async function fetchCustomAttributeData(optionId) {
  try {
    const res = await fetch(`https://ofm.stran.store/api/magento/products/attributes/${optionId}/options`);
    const json = await res.json();

    return Array.isArray(json) ? json : [];
  } catch (err) {
    console.error('Error fetching custom attributes:', err);
    return [];
  }
}

export const submitOrder = async (orderData) => {
  try {
    const res = await fetch('https://ofm.stran.store/api/magento/products/checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    });

    const data = await res.json();

    if (!res.ok) {
      const errorMessage = data?.error || 'Failed to submit order';
      throw new Error(errorMessage);
    }

    return data
  } catch (error) {
    console.error('Error submitting order:', error.message || error);
    throw error;
  }
};

const LAMBDA_URL =
  "https://tzdez6wzydhrmt5ncjqkx5dcsu0olvwh.lambda-url.us-east-1.on.aws/";

const BATCH_SIZE = 200;

export async function submitFile({ context, records, onProgress }) {
  const totalBatches = Math.ceil(records.length / BATCH_SIZE);

  for (let i = 0; i < records.length; i += BATCH_SIZE) {
    const batch = records.slice(i, i + BATCH_SIZE);

    try {
      await fetch(LAMBDA_URL, {
        method: "POST",
        body: JSON.stringify({
          context,
          batch_index: Math.floor(i / BATCH_SIZE) + 1,
          total_batches: totalBatches,
          record_count: batch.length,
          records: batch
        })
      });

      if (onProgress) {
        onProgress(Math.floor(i / BATCH_SIZE) + 1, totalBatches);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      throw new Error("Failed to upload batch " + (Math.floor(i / BATCH_SIZE) + 1));
    }
  }
}





